import type { RemoteConfigPolicy } from './remoteConfigKeys';

export const isEmptyAllowList = (value: unknown): boolean => {
  if (value == null) return true;
  if (typeof value === 'object' && !Array.isArray(value)) {
    return Object.keys(value as Record<string, unknown>).length === 0;
  }
  return false;
};

const hasOrgsAllowed = (value: unknown): value is { orgsAllowed: unknown } =>
  typeof value === 'object' && value != null && !Array.isArray(value) && 'orgsAllowed' in value;

export const isRemoteConfigOrgAllowed = (
  value: unknown,
  orgId: string | undefined,
  policy: RemoteConfigPolicy,
): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (policy.shape === 'orgsAllowed') {
    if (!orgId || !hasOrgsAllowed(value) || !Array.isArray(value.orgsAllowed)) {
      return false;
    }
    return value.orgsAllowed.includes(orgId);
  }

  if (isEmptyAllowList(value)) {
    return policy.empty === 'allow';
  }
  if (!orgId || typeof value !== 'object' || value == null || Array.isArray(value)) {
    return false;
  }
  return Boolean((value as Record<string, unknown>)[orgId]);
};
